import React from 'react';
import { PropTypes } from 'prop-types';
import NoImage from '../../../../../../pagesV2/Sites/imagePlaceholder1.png';

const containerStyles = {
  height: 350,
  width: '100%',
  minWidth: '100%',
};

const imgStyles = {
  objectFit: 'contain',
};

const CarouselSiteImage = ({
  image = '',
  imageID = -1,
  isPrimaryImage = true,
  children = null,
}) => {
  return (
    <div
      style={containerStyles}
      className={`carousel-item  ${isPrimaryImage ? 'active' : ''}`}
    >
      <img
        src={image || NoImage}
        className="d-block w-100 h-100 rounded-10px"
        alt={`${imageID} slide`}
        style={imgStyles}
      />
      {children}
    </div>
  );
};

CarouselSiteImage.propTypes = {
  image: PropTypes.string,
  imageID: PropTypes.number,
  isPrimaryImage: PropTypes.bool,
  children: PropTypes.node,
};

export default CarouselSiteImage;
